import { Button } from '@mote/ui'
import type { SystemProps } from '@xstyled/styled-components'
import { x } from '@xstyled/styled-components'
import type { Choice } from '../typings'

const cardStylingProps: SystemProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  w: 'full',
  h: '48px',
  text: 'lg',
  fontWeight: 'medium',
  color: 'black',
  borderRadius: 'md',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: 'primary.base'
}

export interface StepChoiceProps extends Pick<Choice, 'icon' | 'text'> {
  isSelected: boolean
  onClick?: () => void
  testId?: string | boolean
}

export const StepChoice = (props: StepChoiceProps) => {
  if (props.isSelected) {
    return (
      <x.span {...cardStylingProps} data-testid={props.testId}>
        <>
          {props.icon ? (
            <x.span
              display='flex'
              alignItems='center'
              justifyContent='center'
              role='img'
              aria-label='emoji'
              w={6}
              h={6}
              text='lg'
            >
              {props.icon}
            </x.span>
          ) : null}
          {props.text}
        </>
      </x.span>
    )
  }

  return (
    <Button
      //@ts-expect-error
      variant='secondary'
      size='lg'
      onClick={() => props.onClick?.()}
      icon={props.icon}
      text={props.text}
      block
      data-testid={props.testId}
    />
  )
}
